import axiosInstance from "./Api";
import TokenService from "./TokenService";
import router from "@/router/index";
import store from "@/store";
import utils from "@/utils/index";
import { useToast } from "vue-toastification";
import $bus from "@/utils/event.js";
const toast = useToast();
var timeOut;

const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();

      if (config.data instanceof FormData) {
        config.headers["Content-Type"] = "multipart/form-data";
      }

      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      const publicRequestPaths = [
        "/v1/releases/public",
        "/v1/ConfiguracaoWhiteLabel/CarregarUrl/",
      ];
      const isPublicRequest = publicRequestPaths.some((path) =>
        originalConfig?.url?.startsWith(path)
      );

      if (
        !isPublicRequest &&
        originalConfig?.url !== "/v1/auth/login/" &&
        err.response &&
        originalConfig?.url !== "/v1/auth/refresh-token/"
      ) {
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;

          try {
            const rs = await axiosInstance.post("/v1/auth/refresh-token/", {
              AccessToken: TokenService.getLocalAccessToken(),
              RefreshToken: TokenService.getLocalRefreshToken(),
            });

            if (rs.data.Data.Token) {
              TokenService.setUser(rs.data.Data);
            }

            return axiosInstance(originalConfig);
          } catch (_error) {
            if (
              _error.response.status === 401 &&
              _error.config.url === "/v1/auth/refresh-token/"
            ) {
              let tokenExpires = TokenService.getLocalTokenExpires();
              if (
                tokenExpires === null ||
                tokenExpires === undefined ||
                new Date(tokenExpires) <= new Date()
              ) {
                clearTimeout(timeOut);
                timeOut = setTimeout(logout, 1000);
              }
            }
            return Promise.reject(_error);
          }
        }
      }

      return Promise.reject(err);
    }
  );

  function logout() {
    $bus.trigger("exibirLoadingModalGeral", false);
    store.dispatch("auth/logout").then(() => {
      router.push("/" + utils.getWL() + "/sign-in");
      toast.info("Sessão expirada, por favor faça login novamente!", {
        timeout: 3000,
      });
    });
  }
};

export default setup;
